const PageNotFound = () => (
  <h1 style={{ alignContent: 'center' }}>Page not found</h1>
);

export default PageNotFound;
